import React, { useState, lazy, Suspense, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useRecoilState } from 'recoil';
import axios from 'api/request';
import { useMutation } from 'react-query';
import { OrderPayload, orderId as cmpOrderId, orderSuccessPopup } from 'pages/myidm/store';
import { getAdGroupOwnerChangePayload } from 'pages/myidm/utils/getPayload';
import { endPoints } from 'api/endpoints';
import { isReadyToSubmitForGroupOwnerChange } from 'pages/myidm/utils';
import { OrderSuccessDialog } from 'pages/myidm/components/order-success';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';

const ErrorBanner = lazy(() => import('pages/myidm/components/error-banner'));

export const SubmitRequest = () => {
    const { orderId, operation } = useParams();
    const [, setOrderId] = useRecoilState(cmpOrderId);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [isSuccessOpen, setSuccessPopup] = useRecoilState(orderSuccessPopup);
    const [errorBannerOpen, setErrorBannerOpen] = useState(false);
    const submitOrderApi = useMutation((payload) => axios.post(endPoints?.myIdm?.Jwt?.newADGroupMembership, payload));

    const resetForm = () => {
        setOrder({
            ...order,
            adGroup: null,
            businessApplication: null,
            businessApplicationDetails: null,
            environment: null,
            envShortName: null,
            sector: null,
            AppShortName: null,
            applicationName: null,
            adGroupType: null,
            adGroupTypeDetails: null,
            groupOwner: null,
            groupOwnerDetails: null,
            appService: null,
            members: null,
            mypamsafeDetails: [],
            nonSafeDetailsGpid: [],
            multipleAdGroups: [{ adGroup: null, adGroupOwner: null, members: [] }],
            appOwner: null,
            appOwnerDetails: null,
            isTouched: false,
        });
    };
    const handleSubmit = async () => {
        const payload = getAdGroupOwnerChangePayload({ order });
        submitOrderApi.mutate(payload);
    };

    const handleValidation = () => {
        const validationStatus = isReadyToSubmitForGroupOwnerChange({ order });
        if (validationStatus?.isValid) {
            handleSubmit();
        } else {
            setErrorBannerOpen(true);
            setOrder({
                ...order,
                isTouched: true,
            });
        }
    };
    const handleReset = () => {
        setSuccessPopup(false);
        resetForm();
    };
    useEffect(() => {
        if (submitOrderApi?.data?.data?.orderId) {
            setOrderId(submitOrderApi?.data?.data?.orderId);
            setSuccessPopup(true);
        } else {
            setSuccessPopup(false);
        }
    }, [submitOrderApi?.isSuccess]);
    return (
        <Suspense
            fallback={
                <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" height="calc(100vh - 100px)" width="100%">
                    <CircularProgress color="inherit" size={16} sx={{ color: '#000000' }} />
                    <Typography variant="body2" sx={{ color: '#000000' }}>
                        Loading
                    </Typography>
                </Box>
            }
        >
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {!orderId && !operation && (
                    <Btn
                        size="medium"
                        onClick={() => handleValidation()}
                        variant="contained"
                        disabled={submitOrderApi?.isLoading}
                        // sx={ProvisioningStyles?.cartBtn}
                        sx={{ ...style.primaryMediumButton, width: '150px' }}
                        data-testid="add-to-cart-btn"
                    >
                        {submitOrderApi?.isLoading ? <CircularProgress color="inherit" size={16} /> : 'Submit Request'}
                    </Btn>
                )}
            </Box>
            <OrderSuccessDialog isOpen={isSuccessOpen} reset={handleReset} redirectUrl="/access-management-myidm/DAY2ADDMEMBERS" type={operation} />
            {errorBannerOpen && (
                <ErrorBanner
                    show={errorBannerOpen}
                    message="Error! Please fill out the missing values marked with the * asterisk and click submit request."
                    handleCloseCallback={() => setErrorBannerOpen(false)}
                />
            )}
        </Suspense>
    );
};

SubmitRequest.propTypes = {};

SubmitRequest.defaultProps = {};

export default React.memo(SubmitRequest);
